import {
  Box,
  Grid,
  Paper,
  Typography,
  Avatar,
  Stack,
  IconButton,
  StepLabel,
  Step,
  Stepper,
  CircularProgress,
  Snackbar,
  Alert,
  Button,
  Chip,
  Badge,
  Popover,
  FormControl,
  Select,
  MenuItem,
  Tabs,
  Tab,
  Pagination,
  Modal,
} from "@mui/material";
import GroupsIcon from "@mui/icons-material/Groups";
import { useDispatch } from "react-redux";
import Slider from "react-slick";
import {
  getApplicants,
  getSinglePostedJob,
} from "../../../Redux/Reducers/JobReducer";
import { useSelector } from "react-redux";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useRef, useState } from "react";
import JobsCard from "./SideFeedComponents/JobsCard";

const RecruiterJobs = () => {
  const Jobs = useSelector((state) => state?.jobs?.postedJobsData) || [];
  const postedJobs = Jobs?.posted_jobs;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const sliderRef = useRef(null);

  const handleJobClick = (jobId, index) => {
    dispatch(getSinglePostedJob(jobId));
    dispatch(getApplicants({ job_id: jobId }));

    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index);
    }
  };

  const NoJobsFound = () => (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "150px",
        border: "1px dashed #ccc",
        borderRadius: 1,
        margin: "20px 0",
      }}
    >
      <Typography variant="h6" color="text.secondary">
        No Jobs Posted
      </Typography>
      <Typography variant="body2" color="text.secondary" mt={1}>
        Start by posting your first job
      </Typography>
    </Box>
  );

  const CustomNextArrow = ({ onClick }) => (
    <IconButton
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "50%",
        right: "-10px", // Moved further right
        bgcolor: "#0044C61A",
        transform: "translateY(-50%)",
        color: "#0044C6",
        zIndex: 1,
        "&:hover": {
          bgcolor: "#d1e2ff",
          color: "#002699",
        },
      }}
    >
      <ArrowForwardIosIcon />
    </IconButton>
  );

  const CustomPrevArrow = ({ onClick }) => (
    <IconButton
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "50%",
        left: "-10px", // Moved further left
        bgcolor: "#0044C61A",
        transform: "translateY(-50%)",
        color: "#0044C6",
        zIndex: 1,
        "&:hover": {
          bgcolor: "#d1e2ff",
          color: "#002699",
        },
      }}
    >
      <ArrowBackIosIcon />
    </IconButton>
  );

  const sliderSettings = {
    dots: false,
    infinite: postedJobs?.length > 3,
    ref: sliderRef, // Add this line
    initialSlide: 0,
    speed: 500,
    speed: 500,
    slidesToShow: Math.min(3, postedJobs?.length),
    slidesToScroll: 1,
    arrows: postedJobs?.length > 3,
    marginRight: 3,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(2, postedJobs?.length),
          slidesToScroll: 1,
          arrows: postedJobs?.length > 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: postedJobs?.length > 1,
        },
      },
    ],
    adaptiveHeight: true,
  };

const renderPostedDate = (date) => {
  const postedDate = new Date(date);
  const now = new Date();
  const diffInMs = now - postedDate;

  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  const diffInMonths = Math.floor(diffInDays / 30);
  const diffInYears = Math.floor(diffInDays / 365);

  if (diffInMinutes < 1) {
    return "just now";
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes}m ${diffInMinutes === 1 ? "" :""} ago`;
  } else if (diffInHours < 24) {
    return `${diffInHours}h ${diffInHours === 1 ? "" : ""} ago`;
  } else if (diffInDays === 1) {
    return "1d ago";
  } else if (diffInDays < 30) {
    return `${diffInDays}d ago`;
  } else if (diffInMonths < 12) {
    return `${diffInMonths}m ${diffInMonths === 1 ? "" : ""} ago`;
  } else {
    return `${diffInYears}y ${diffInYears === 1 ? "" : ""} ago`;
  }
};

  const calculateDaysAgo = (date) => {
    const postedDate = new Date(date);
    const today = new Date();
    const differenceInTime = today - postedDate; // Difference in milliseconds
    const differenceInDays = Math.floor(
      differenceInTime / (1000 * 60 * 60 * 24)
    ); // Convert to days
    return differenceInDays;
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" gutterBottom sx={{ fontSize: "14px" }}>
          Posted Jobs
        </Typography>
        <Typography variant="h6" gutterBottom>
          <a
            href="/alljobs"
            style={{ textDecoration: "none", fontSize: "14px" }}
          >
            View All
          </a>
        </Typography>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", my: 3 }}>
          <CircularProgress />
        </Box>
      ) : !postedJobs || postedJobs?.length === 0 ? (
        <NoJobsFound />
      ) : postedJobs?.length <= 3 ? (
        // Show cards in a row when 3 or fewer cards
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mt: 2,
              }}
            >
              {postedJobs?.map((card, index) => (
                <Box key={card.id} sx={{ mr: index !== postedJobs.length - 1 ? "5px" : 0 }}>
                  <JobsCard
                    index={index}
                    card={card}
                    handleJobClick={() => handleJobClick(card.id, index)}
                  />
                </Box>
              ))}
            </Box>

      ) : (
        <Slider {...sliderSettings} className="slick-margin-1rem">
          {postedJobs?.map((card, index) => (
            <JobsCard
              key={card.id}
              index={index}
              card={card}
              handleJobClick={() => handleJobClick(card.id, index)}
            />
          ))}
        </Slider>
      )}
    </>
  );
};

export default RecruiterJobs;
